import { render, staticRenderFns } from "./_CARD.vue?vue&type=template&id=91a81ade&"
import script from "./_CARD.vue?vue&type=script&lang=js&"
export * from "./_CARD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports